import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_COLOR = "/logo-horizontal.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [secretTaps, setSecretTaps] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (secretTaps >= 3) { navigate("/$$login"); setSecretTaps(0); }
    if (secretTaps > 0) { const t = setTimeout(() => setSecretTaps(0), 1500); return () => clearTimeout(t); }
  }, [secretTaps, navigate]);

  const handleContactClick = () => {
    setSecretTaps(prev => prev + 1);
    goToSection("contatti");
  };

  const goToSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/#" + id);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { label: "Progetti", action: () => { setOpen(false); navigate("/projects"); } },
    { label: "Team", action: () => { setOpen(false); navigate("/team"); } },
    { label: "News", action: () => { setOpen(false); navigate("/news"); } },
  ];

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-[#f0f0ef]'}`} data-testid="main-navbar">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img src={LOGO_COLOR} alt="PX Group" className="h-7" />
          </Link>

          <div className="hidden md:flex items-center gap-7 lg:gap-8">
            {navItems.map((item) => (
              <button key={item.label} onClick={item.action} className="text-sm font-medium text-[#0f292f]/60 hover:text-[#0f292f] transition-colors" data-testid={`nav-${item.label.toLowerCase()}`}>{item.label}</button>
            ))}
            <button onClick={handleContactClick} className="bg-[#0f292f] text-white text-sm font-medium px-5 py-2 rounded-full hover:bg-[#0f292f]/85 transition-all" data-testid="nav-contatti-btn">Contattaci</button>
            <a href="https://wa.me/390297376589" target="_blank" rel="noopener noreferrer" aria-label="Scrivici su WhatsApp" title="Scrivici su WhatsApp" data-testid="nav-whatsapp-btn" className="w-9 h-9 inline-flex items-center justify-center rounded-full bg-[#25D366] text-white hover:bg-[#1eb457] transition-all">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2z"/></svg>
            </a>
          </div>

          <button onClick={() => setOpen(!open)} className="md:hidden text-[#0f292f]" data-testid="mobile-menu-toggle">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-6 py-4 space-y-3">
            {navItems.map((item) => (<button key={item.label} onClick={item.action} className="block w-full text-left text-[#0f292f]/70 hover:text-[#0f292f] py-2">{item.label}</button>))}
            <div className="pt-2 space-y-2">
              <button onClick={handleContactClick} className="bg-[#0f292f] text-white w-full text-center py-2.5 rounded-full font-medium">Contattaci</button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
